import * as React from "react"

import { cn } from "../../lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-sm border border-gray-300 bg-white px-4 text-sm shadow-sm",
        "placeholder:text-gray-400",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-blue-500 focus-visible:border-blue-500",
        "disabled:cursor-not-allowed disabled:bg-gray-100 disabled:opacity-70",
        "transition-all duration-200",
        className
      )}

      ref={ref}
      {...props} />
  )
})
Input.displayName = "Input"

export { Input }
